import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { PillButton } from './PillButton';
type ConfirmDialogProps = {
  title: string;
  message: string;
  confirmLabel: string;
  discardLabel: string;
  onConfirm: () => void;
  onDiscard: () => void;
  onCancel: () => void;
  cancelLabel?: string;
};
export function ConfirmDialog({
  title,
  message,
  confirmLabel,
  discardLabel,
  onConfirm,
  onDiscard,
  onCancel,
  cancelLabel = 'Keep Editing'
}: ConfirmDialogProps) {
  const confirmRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    confirmRef.current?.focus();
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onCancel();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onCancel]);
  return <motion.div className="fixed inset-0 z-50 flex items-center justify-center bg-[#1b2129]/30" initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.15
  }} onMouseDown={e => e.target === e.currentTarget && onCancel()} data-id="element-815" data-mp="3nzrxq79mgq9t">
      
      <motion.div role="alertdialog" aria-modal="true" aria-labelledby="confirm-title" aria-describedby="confirm-message" className="w-[320px] rounded-[8px] bg-white p-4 shadow-[0_8px_30px_rgba(20,28,38,0.22)]" initial={{
      opacity: 0,
      scale: 0.96
    }} animate={{
      opacity: 1,
      scale: 1
    }} exit={{
      opacity: 0,
      scale: 0.96
    }} transition={{
      duration: 0.2,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-816" data-mp="2o3ucbgfa3p64">
        
        <h2 id="confirm-title" className="text-[14px] font-bold text-pf-ink" data-id="element-817" data-mp="20d740u1gaxj1">
          {title}
        </h2>
        <p id="confirm-message" className="mt-1 text-[12px] leading-snug text-pf-muted" data-id="element-818" data-mp="1vednesqvaqen">
          {message}
        </p>
        <div className="mt-4 flex items-center gap-2" data-id="element-819" data-mp="3urhnso36v1hy">
          <button type="button" onClick={onCancel} className="mr-auto text-[12px] text-pf-muted hover:text-pf-ink" data-id="element-820" data-mp="3uoviyw7on03f">
            {cancelLabel}
          </button>
          <PillButton className="flex-none px-4" onClick={onDiscard} data-id="element-821" data-mp="1o27eufb8niv6">
            {discardLabel}
          </PillButton>
          <PillButton ref={confirmRef} variant="primary" className="flex-none px-4" onClick={onConfirm} data-id="element-822" data-mp="1sv0kr6ig0x8u">
            {confirmLabel}
          </PillButton>
        </div>
      </motion.div>
    </motion.div>;
}